import { useMediaQuery } from "@mantine/hooks";

export const useIsMobile = () => {
  const isMobile = useMediaQuery("(max-width: 48em)");
  //  console.log("isMobile: ", isMobile);
  return isMobile;
};
